import { render } from "./AllInstances.vue?vue&type=template&id=1c92d278"
import script from "./AllInstances.vue?vue&type=script&lang=js"
export * from "./AllInstances.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__